import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import './Contact.css';

const Contact: React.FC = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

//   const handleSubmit = async (e: React.FormEvent) => {
//   e.preventDefault();

//   try {
//     // const res = await fetch('http://localhost:4000/contact/send', {
//     const res = await fetch('https://ajeragroup-backend.onrender.com/contact/send', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(form),
//     });

//     const result = await res.json();

//     if (result.success) {
//       alert('✅ Message sent successfully!');
//       setForm({
//         name: '',
//         email: '',
//         subject: 'General Inquiry',
//         message: '',
//       });
//     } else {
//       alert('❌ Failed to send message');
//     }
//   } catch (error) {
//     alert('❌ Server error');
//   }
// };

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  if (loading) return;

  setLoading(true);

  try {
    const res = await fetch(
      "https://ajeragroup-backend.onrender.com/contact/send",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      }
    );

    const result = await res.json();

    if (result.success) {
      alert("✅ Message sent successfully!");
      setForm({
        name: "",
        email: "",
        subject: "General Inquiry",
        message: "",
      });
    } else {
      alert("❌ Failed to send message");
    }
  } catch (error) {
    alert("❌ Server error");
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      <PageHeader
        breadcrumb="Contact Us"
        title="Get in Touch"
        subtitle="We'd love to hear from you. Reach out to any of our teams."
      />

      <div className="contact-page">
        {/* Left info */}
        <div className="contact-info">
          <h1>Let's talk<br />about your goals.</h1>
          <p>
            Whether you're looking to partner with us, explore our services, or join our
            team — we're just a message away.
          </p>

          <div className="contact-item">
            <div className="contact-icon">📧</div>
            <div>
              <div className="contact-label">Email</div>
              <span>contact@ajeragroup.com</span>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-icon">📍</div>
            <div>
              <div className="contact-label">Address</div>
              <span>Tamil Nadu, India</span>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-icon">🌐</div>
            <div>
              <div className="contact-label">Website</div>
              <span>wwww.ajeragroup.com</span>
            </div>
          </div>
        </div>

        {/* Right form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Send us a message</h2>

          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Your full name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="your@email.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Subject</label>
            <select name="subject" value={form.subject} onChange={handleChange}>
              <option>General Inquiry</option>
              <option>Agro Export</option>
              <option>IT Solutions</option>
              <option>Construction</option>
              <option>Careers</option>
              <option>Partnership</option>
            </select>
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea
              name="message"
              placeholder="Tell us how we can help..."
              value={form.message}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="submit-btn"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Message →"}
          </button>
        </form>
      </div>
    </>
  );
};

export default Contact;
